<template>
    <div class="col-lg-4">
        <b-card class="budget-wrapper">
 
            <b-dropdown
            text="2020"
            size="sm"
            class="budget-dropdown d-flex mt-4"
            variant="outline-primary"
            > 
                <b-dropdown-item
                    v-for="year in data.years"
                    :key="year"
                >
                    {{ year }}
                </b-dropdown-item>
            </b-dropdown>
            <div class="">
                <b-card-title class="mb-1 mt-2">
                    Yearly Earnings
                </b-card-title>
                <h4 class="font-weight-normal">56,800</h4>
            </div>
            <b-button
            variant="primary"
            class="mt-2"
            >
            Get Earnings
            </b-button>


        </b-card>
    </div>
</template>
<script>
import {
  BCard, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue-3'
import VueApexCharts from 'vue3-apexcharts'

export default {
    name:'yearlyEarningsComponent',
    components:{
        BDropdown,
        BDropdownItem,
        BCard,
        BButton,
        BRow,
        BCol,
        VueApexCharts
    },
    props: {
        data: {
        type: Object,
        default: () => {},
        },
    },
    data() {
        return {

        }
    },
    mounted() {
        this.getGet();
    },
    methods:{
        getGet(){
            console.log(this.data.price);
        }
    }
    
}
</script>
<style scoped>
    .budget-wrapper {
        padding: 2rem 3rem;
        text-align: center;
    }
</style>